import { portfolioData } from '../../../mocks/portfolio';

export default function FeaturedProject() {
  const { featuredProject } = portfolioData;

  return (
    <section className="bg-[#f9f6f2] py-32">
      <div className="container mx-auto px-6 lg:px-12 max-w-6xl">
        {/* Visual Container */}
        <div className="rounded-3xl overflow-hidden mb-16 shadow-2xl">
          <img 
            src={featuredProject.image}
            alt={featuredProject.title}
            className="w-full h-auto object-cover"
            style={{ filter: 'contrast(1.05) brightness(0.98)' }}
          />
        </div>

        {/* Text Content */}
        <div className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="text-[#1a1a1a] text-4xl lg:text-5xl font-bold leading-tight mb-8">
            {featuredProject.title}
          </h2>
          <p className="text-[#888888] text-2xl lg:text-3xl leading-relaxed mb-8 font-light">
            {featuredProject.description}
          </p>
          
          {/* Detailed Information */}
          <div className="space-y-6 text-left">
            {featuredProject.details.map((detail, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-md">
                <p className="text-[#2a2a2a] text-lg leading-relaxed">
                  {detail}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button className="bg-[#1a1a1a] text-white px-12 py-4 rounded-full text-lg font-semibold hover:bg-[#2a2a2a] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
            全プロジェクトを見る
          </button>
        </div>
      </div>
    </section>
  );
}